export enum HttpStatusCode {
  OK = '200',
  CREATED = '201',
  ACCEPTED = '202',
  NO_CONTENT = '204',
  BAD_REQUEST = '400',
  UNAUTHORIZED = '401',
  FORBIDDEN = '403',
  NOT_FOUND = '404',
  TIMEOUT = '408',
  CONFLICT = '409',
  TEAPOT = '418',
  UNPROCESSABLE_ENTITY = '422',
  LOCKED = '423',
  TOO_MANY_REQUESTS = '429',
  BAD_GATEWAY = '502',
  INTERNAL_SERVER_ERROR = '500',
  SERVER_NOT_AVAILABLE = '503'
}
